import {Kind, SelectionNode} from 'query-api-graphql';

import {assert} from 'Asserts';

/**
 * Count number of selected leaf fields in an array of selections.
 *
 * Does not handle `FragmentSpread` selections.
 *
 * @example
 * countSelectedFields(getSelectionsFromQuery(`{
 *   id
 *   name
 *   address {
 *     street
 *   }
 * }`))
 *   -> 3
 *
 * @example
 * countSelectedFields(getSelectionsFromQuery(`{
 *   id
 *   name
 *   ... on User {
 *     email
 *     organization {
 *       handle
 *     }
 *   }
 * }`))
 *   -> 4
 */
export default function countSelectedFields(selections: ReadonlyArray<SelectionNode>): number {
  return selections
    .map((selection) => {
      if (selection.kind === Kind.FIELD) {
        if (selection.selectionSet != null) {
          return countSelectedFields(selection.selectionSet.selections);
        } else {
          return 1;
        }
      } else {
        assert(selection.kind === Kind.INLINE_FRAGMENT, `Got unexpected selection kind ${selection.kind}`);
        return countSelectedFields(selection.selectionSet.selections);
      }
    })
    .reduce((acc, curr) => acc + curr, 0);
}
